export default "__VITE_ASSET__79563d35__"